import { Currency, ETHER, Token } from '@padiswap/sdk'

export function currencyId(currency: Currency): string {
  if (currency === ETHER) return 'REI'
  if (currency instanceof Token) return currency.address
  throw new Error('invalid currency')
}

export default currencyId
